import { useContext } from "react";

import { ApplicationContext } from "@swa-ui/application";
import { useDeviceInfo } from "@swa-ui/browser";

export const useNavigationType = () => {
  const { site } = useContext(ApplicationContext);
  const { isLargeOrXlarge } = useDeviceInfo();
  const isDesktopSite = site === "southwest";
  const isResponsive =
    site === "external" || site === "corporate" || process.env.NODE_ENV === "development";

  return (isResponsive && isLargeOrXlarge) || (!isResponsive && isDesktopSite)
    ? "desktop"
    : "mobile";
};
